import { ReactElement } from 'react';
import Collapsible from 'app/shared/components/Collapsible/Collapsible';
import ReviewSection, {
  IReviewSectionProps,
} from 'app/shared/components/ModelReview/ReviewSection/ReviewSection';
import { Typography } from 'app/shared/components/Typography/Typography';

const CollapsibleReviewSection = (props: IReviewSectionProps): ReactElement => {
  return (
    <Collapsible
      id={props.slug}
      header={
        <Typography Component={'h2'} variant={'body3'}>
          {props.mainSection.heading}
        </Typography>
      }
    >
      <ReviewSection {...props} showMainHeading={false} />
    </Collapsible>
  );
};

export default CollapsibleReviewSection;
